<div class="p-3">
  <h5 class="text-primary mb-3">Airplay credentials</h5>
  <form [formGroup]="extraDataForm">
    <div>
      <label for="airplayUsername"
             class="form-label visually-hidden">Username</label>
      <input type="text"
             class="form-control"
             id="airplayUsername"
             formControlName="airplayUsername" />
    </div>
    <div>
      <label for="airplayPassword"
             class="form-label visually-hidden">Password</label>
      <input type="text"
             class="form-control"
             id="airplayPassword"
             formControlName="airplayPassword" />
    </div>
    <button class="btn btn-primary mb-3"
            (click)="onSubmit()">Save</button>
  </form>

  <h5 class="text-primary mb-3">Cloud token</h5>
  <form [formGroup]="tokenForm">
    <div class="me-2">
      <label for="token"
             class="form-label visually-hidden">Token</label>
      <input type="text"
             class="form-control"
             id="token"
             formControlName="token" />
    </div>

    <button class="btn btn-primary"
            (click)="onSubmitToken()">Save</button>
  </form>
</div>